import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Spin } from "antd";
import { ToastContainer } from "react-toastify";
import "antd/dist/antd.css";
import "react-toastify/dist/ReactToastify.css";
import "./style.scss";

import { settings } from "../../settings";
import translations from "../Common/translations.json";
import { TitleBlock } from "../MainPage/components/TitlesBlock";
import { PersonalDetail } from "../MainPage/components/PersonalDetail";
import { EventPreferences } from "./components/EventPreferences";
import { TriggerPreferences } from "./components/TriggerPreferences";
import { ButtonsBlock } from "./components/ButtonsBlock";
import { ModalNewSubscription } from "./components/ModalNewSubscription";

export const NewsEventPage = ({ styles = {}, isAppReady = false }) => {
  const subscription = useSelector((state) => state.newsEventPage.subscription);
  const listing = useSelector((state) => state.newsEventPage.listing);
  const [modalNewSubscriptionIsOpen, setModalSubscribeIsOpen] = useState(false);

  const translation = translations[settings.lang];
  const newsEvent = translation.newsEvent;

  // The subscription only carries the English company name, so the Arabic one
  // comes from the listing that was resolved alongside it.
  const companyName =
    settings.lang === "ar" && listing.name_ar
      ? listing.name_ar
      : subscription.companyName;

  const getFontFamily = () => ({
    fontFamily:
      settings.lang === "ar"
        ? "Hanifonts"
        : styles && styles.fontFamily && styles.fontFamily[settings.lang],
  });

  const getActivationHeader = () => {
    if (settings.activate !== "true") return null;
    return (
      <div className="news-event-confirmed-block">
        <span className="news-event-confirmed-title">
          {newsEvent.modalStrings.subscriptionConfirmed}
        </span>
      </div>
    );
  };

  const fonts = styles.fonts || {};
  const backgroundColors = styles.backgroundColors || {};

  return (
    <div className="news-event-wrapper" style={getFontFamily()}>
      {!isAppReady ? (
        <div className="spiner-wrapper">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div className="news-event-company-title-block">
            <span
              className="news-event-company-title"
              style={{ color: fonts.body }}
            >
              {companyName}
            </span>
          </div>
          {getActivationHeader()}

          <div className="news-event-detail-wrapper">
            <div className="news-event-detail-block">
              <span
                className="news-event-detail-title"
                style={{ color: fonts.body }}
              >
                {newsEvent.titles.subscriptionDetailTitle}
              </span>
            </div>

            <div className="news-event-preferences-block">
              <TitleBlock
                title={newsEvent.titles.eventPreferencesTitle}
                backgroundColors={backgroundColors}
                fonts={fonts}
              />
              <EventPreferences
                translation={newsEvent.eventPreferences}
                themeLabels={newsEvent.themes}
                fonts={fonts}
              />
            </div>

            <div className="news-event-triggers-block">
              <TitleBlock
                title={newsEvent.titles.notificationTimingTitle}
                backgroundColors={backgroundColors}
                fonts={fonts}
              />
              <TriggerPreferences
                translation={newsEvent.triggers}
                fonts={fonts}
              />
            </div>

            <div className="news-event-personal-block">
              <TitleBlock
                title={translation.titles.personalDetailTitle}
                backgroundColors={backgroundColors}
                fonts={fonts}
              />
              <PersonalDetail
                translation={translation.personalDetail}
                setModalSudscribeIsOpen={setModalSubscribeIsOpen}
                emailSubscription={subscription.email}
                fonts={fonts}
              />
              <ButtonsBlock
                translation={translation}
                modalStrings={translation.modalStrings}
                fonts={fonts}
              />
            </div>

            <ModalNewSubscription
              isOpenModel={modalNewSubscriptionIsOpen}
              buttonCloseHandler={() => setModalSubscribeIsOpen(false)}
              translation={translation}
              themeLabels={newsEvent.themes}
              fonts={fonts}
            />
          </div>
          <ToastContainer autoClose={5000} hideProgressBar={true} />
        </>
      )}
    </div>
  );
};
